// extracted by mini-css-extract-plugin
export default {"Checkbox":"archive-item-module__Checkbox--zW2ni"};